import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const projectSensors = {
  'app.projectSensors':     (pId=':projectId') =>  `${prefix}/projects/${pId}/sensors`
}
